import styled from 'styled-components'

export const ItemsToReturnContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`
